import { render, staticRenderFns } from "./PipelineValidationNotification.vue?vue&type=template&id=01b4becc"
import script from "./PipelineValidationNotification.vue?vue&type=script&lang=ts"
export * from "./PipelineValidationNotification.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./PipelineValidationNotification.vue?vue&type=style&index=0&id=01b4becc&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports